export class TransCompliance {
    Id!: number;
    ComplianceId!: number;
    FromDate!: Date;
    ToDate!: Date;
    CreatedBy!: string;
    CreatedDate!: Date;
    UpdatedBy!: string;
    UpdatedDate ? :Date;
}
